import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { ConfirmOrderService } from './confirm-order.service';
import { NotificationsService } from '../shared/notifications.service';

@Component({
  selector: 'app-confirm-order',
  providers: [ConfirmOrderService],
  templateUrl: './confirm-order.component.html',
  styleUrls: ['./confirm-order.component.css']
})
export class ConfirmOrderComponent implements OnInit {
busy: Promise<any>;
successMessage=false;
errorMessage=false;
message='';
  constructor(
    public router: Router,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private confirmService: ConfirmOrderService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    // subscribe to router event
    this.activatedRoute.params.subscribe((params: Params) => {
      if(params['token'] && params['id']){
        let appointment_id = params['id'];
        let token = params['token'];
        this.busy = this.confirmService.order({appointment_id, token}).then(
          (res: any) => {
            this.message = res.msg;
            this.successMessage = true;
            this.errorMessage = false;
          },
          (error) => {
          this.message = error.json().msg;
            this.successMessage = false;
            this.errorMessage = true;
          }
        );
      }
    });
  }








}



// WEBPACK FOOTER //
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/app/confirm-order/confirm-order.component.ts